module.exports = __webpack_public_path__ + "static/media/PC_Carrosel_DESIGN_SPRINT.109adb23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/design_sprint/PC_Carrosel_DESIGN_SPRINT.png
// module id = 281
// module chunks = 0